export enum tabIndexes {
  portfolio,
  projects,
  earlyWarnings,
  reviews,
  settings,
  userSettings,
  contentManager,
}

export enum contentManagerTabIndexes {
  contents,
  translations,
  functionDelegations,
  add,
  analytics,
  holidays,
  backToCartera,
}

export enum contentsTabIndexes {
  helpCenter,
  messages,
  maintenance,
  notifications,
  recommended
}
